import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { FONTS } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  textWrapper: {
    padding: 8,
    textAlign: 'center',
  },
  title: {
    '&&': {
      fontSize: FONTS.SIZES.m,
      color: theme.palette.custom.darkBlue2,
      fontWeight: FONTS.WEIGHTS.semi_bold,
    },
  },
  locationName: {
    '&&': {
      fontSize: '12px',
      color: theme.palette.custom.darkBlue2,
      fontWeight: FONTS.WEIGHTS.light,
    },
  },
  subtitle: {
    '&&': {
      fontSize: FONTS.SIZES.s,
      color: theme.palette.custom.darkBlue2,
      fontWeight: FONTS.WEIGHTS.light,
    },
  },
}))
